<template>
  <li
    role="button"
    class="d-flex align-center justify-space-between widget-list-item mb-2 rounded px-4 py-3"
    @click="handleWidgetClick"
  >
    <i
      class="d-flex text-h2"
      :class="`pp-icon-${icon}`"
    />
    <h5 class="text-h5 ml-4">
      {{ label }}
    </h5>
    <i
      class="flex-grow-1 text-right pp-icon-caret--right"
    />
  </li>
</template>

<script>
import { mapMutations } from 'vuex'
import { WIDGET_CLICKED_SESSION_KEY } from '@/constants'

export default {
  name: 'WidgetListItem',
  props: {
    icon: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    }
  },
  methods: {
    ...mapMutations({
      setIsWidgetOpen: 'SET_IS_WIDGET_OPEN'
    }),
    handleWidgetClick () {
      this.$emit('widgetClick')
      sessionStorage.setItem(WIDGET_CLICKED_SESSION_KEY, true)
    }
  }
}
</script>
<style lang="scss" scoped>
.widget-list-item {
  background: $grey-20;
  color: $grey-90;

  &:hover {
    color: $grey-100;
  }
}
</style>
